import { CostsRequester, type VehicleRoute } from '@cobliteam/api-lib';
import type { PageableContent } from '@cobliteam/common-types';
import { Environment } from '@cobliteam/react-environments';
import Alert from '@cobliteam/ui/components/Alert';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { loadVehicleRoutesFailed, loadVehicleRoutesSucceeded } from './actionCreators';
import type * as Actions from './actions';
import { ActionTypes } from './actionTypes';

const env = Environment.getInstance().getEnvironment();

const costsRequester = new CostsRequester({ host: env.herbieApiHost });

export function* requestVehicleRoutesSaga(action: Actions.LoadVehicleRoutesRequest) {
  const { period, page, size, filters, sort } = action.payload;

  try {
    const vehicleRoutes: PageableContent<VehicleRoute> = yield call(costsRequester.getVehicleRoutes, period, page, size, filters, sort);
    yield put(loadVehicleRoutesSucceeded(vehicleRoutes));
  } catch (error) {
    yield put(loadVehicleRoutesFailed());
    Alert.error('Houve um erro, tente novamente mais tarde.');
  }
}

export function* RouteHistorySagasListener() {
  yield all([takeLatest(ActionTypes.LOAD_VEHICLE_ROUTES_REQUEST, requestVehicleRoutesSaga)]);
}
